import type { FunctionComponent } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';
import { getTestId } from '@trello/test-ids';

import styles from './BoardTileLargeSkeleton.less';

export const BoardTileLargeSkeleton: FunctionComponent = () => {
  const { value: isRedesignEnabled } = useFeatureGate(
    'trello_personal_productivity_release',
  );

  return (
    <div
      className={isRedesignEnabled ? styles.newTileSkeleton : styles.skeleton}
      data-testid={getTestId('board-loading-skeleton')}
    />
  );
};
